import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WiseIdAuthServiceManager } from '../../controller/wise-id-auth.service-manager';
import { UserService } from "@rfebm/sso-api";
import { UserResult } from '@rfebm/sso-api';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-after-login',
  templateUrl: 'after-login.component.html',
  styleUrls: ['after-login.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class AfterLoginComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private wiseIdAuthServiceManager: WiseIdAuthServiceManager,
    private userService: UserService
  ) { }

  async ngOnInit() {
    var redirect: string = '/login'
    try {
      const queryParams = this.route.snapshot.queryParams; // Get authorization code from query parameters
      const code = queryParams['code'];
      await this.wiseIdAuthServiceManager.loginWithWiseId(code);  // Get access token using the authorization code
      const user: UserResult = await lastValueFrom(this.userService.getMyUser());  // Fetch user data after login
      this.wiseIdAuthServiceManager.setUserSessionData(user); // Save user data in session storage

      redirect = '/home'; // Adjust the redirect URL as needed
    } catch (error) {
      console.error('Sesion expired or not logged in, redirecting to login page.', error);
      redirect = '/login'
    }

    window.location.href = redirect; // Adjust the redirect URL as needed

  }

}
